<div class="pay-confirmation text-center">
    <div class="msg">
        <span class="check-wrap">
            <img src="assets/images/tick.png" alt="checked">
        </span>
        <h3>
            <span>Thank You! Your Reward is on the way Please check your email!</span>
            <br>
        </h3>
    </div>
</div>
